/** Table of Contents scroll highlight */

type TocEntry = {
  link: HTMLAnchorElement
  heading: HTMLElement
  item: HTMLLIElement
}

export function initTOC(): void {
  const tocBody = document.querySelector('.toc-body')
  if (!tocBody) return

  const tocLinks = Array.from(tocBody.querySelectorAll<HTMLAnchorElement>('a'))
  if (tocLinks.length === 0) return

  const idFromHref = (href: string): string => {
    try {
      return decodeURIComponent(href.replace(/^#/, ''))
    } catch {
      return href.replace(/^#/, '')
    }
  }

  const entries: TocEntry[] = []
  for (const link of tocLinks) {
    const id = idFromHref(link.getAttribute('href') || '')
    if (!id) continue
    const heading = document.getElementById(id)
    const item = link.closest('li')
    if (heading && item instanceof HTMLLIElement) {
      entries.push({ link, heading, item })
    }
  }

  if (entries.length === 0) return

  const setActive = (active: HTMLLIElement | null) => {
    for (const entry of entries) {
      entry.item.classList.remove('active')
    }
    active?.classList.add('active')
  }

  setActive(entries[0].item)

  const observer = new IntersectionObserver(
    (observed) => {
      const visible = observed
        .filter((o) => o.isIntersecting)
        .sort((a, b) => (a.boundingClientRect.top || 0) - (b.boundingClientRect.top || 0))

      if (visible.length > 0) {
        const target = entries.find((e) => e.heading === visible[0].target)
        if (target) {
          setActive(target.item)
          return
        }
      }

      const offset = 120
      let current = entries[0]
      for (const entry of entries) {
        if (entry.heading.getBoundingClientRect().top - offset <= 0) {
          current = entry
        }
      }
      setActive(current.item)
    },
    {
      root: null,
      rootMargin: '-100px 0px -55% 0px',
      threshold: [0, 0.25, 0.5, 1],
    },
  )

  for (const entry of entries) {
    observer.observe(entry.heading)
  }
}
